export default __webpack_public_path__ + "static/ShareSection1_it-40b2b9c8539a5d3855e6d2275946aa5b.png";